var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPayshapInfo6 = function SvgPayshapInfo6(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3168_6982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 57.4863V10.4863C12 8.27719 13.7909 6.48633 16 6.48633H48C50.2091 6.48633 52 8.27719 52 10.4863V32.9863",
    stroke: "#F15A22",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7266 13.2122C27.7266 12.5918 28.2295 12.0889 28.8499 12.0889H36.1512C36.7716 12.0889 37.2745 12.5918 37.2745 13.2122C37.2745 13.8325 36.7716 14.3354 36.1512 14.3354H28.8499C28.2295 14.3354 27.7266 13.8325 27.7266 13.2122Z",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9993 44.3195C37.9824 44.3195 42.8327 39.4693 42.8327 33.4862C42.8327 27.5031 37.9824 22.6528 31.9993 22.6528C26.0163 22.6528 21.166 27.5031 21.166 33.4862C21.166 39.4693 26.0163 44.3195 31.9993 44.3195Z",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 33.4865L30.9167 35.6532L35.25 31.3198",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 51.4863,
    width: 20,
    height: 3,
    fill: "#FC4D0F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 57.4863,
    width: 14,
    height: 2,
    fill: "#FC4D0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 52.4863V59.1649C45 61.9315 48.8063 64.1738 53.5 64.1738C58.1937 64.1738 62 61.9315 62 59.1649V52.4863",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 52.4863V59.1649C45 61.9315 48.8063 64.1738 53.5 64.1738C58.1937 64.1738 62 61.9315 62 59.1649V52.4863",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 46.1113V52.7899C45 55.5565 48.8063 57.7988 53.5 57.7988C58.1937 57.7988 62 55.5565 62 52.7899V46.1113",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 46.1113V52.7899C45 55.5565 48.8063 57.7988 53.5 57.7988C58.1937 57.7988 62 55.5565 62 52.7899V46.1113",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 39.7363V46.4149C45 49.1815 48.8063 51.4238 53.5 51.4238C58.1937 51.4238 62 49.1815 62 46.4149V39.7363",
    fill: "#F15A22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 39.7363V46.4149C45 49.1815 48.8063 51.4238 53.5 51.4238C58.1937 51.4238 62 49.1815 62 46.4149V39.7363",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 40.2676C45 41.5356 45.8955 42.7518 47.4896 43.6484C49.0837 44.5451 51.2457 45.0488 53.5 45.0488C55.7543 45.0488 57.9163 44.5451 59.5104 43.6484C61.1045 42.7518 62 41.5356 62 40.2676C62 38.9995 61.1045 37.7834 59.5104 36.8867C57.9163 35.9901 55.7543 35.4863 53.5 35.4863C51.2457 35.4863 49.0837 35.9901 47.4896 36.8867C45.8955 37.7834 45 38.9995 45 40.2676Z",
    fill: "#F15A22",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3168_6982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayshapInfo6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payshap_info_6.8a291d2a.svg";
export { ForwardRef as ReactComponent };